import Vue from 'vue'
import Router from 'vue-router'
import LiveCourseRoutes from '../config/router/liveCourse'
import ExamRoutes from '../config/router/exam'
import ReportRoutes from '../config/router/report'
import BattleRoutes from '../config/router/battle'
import ActivityRoutes from '../config/router/activity'
import CompetitionRoutes from '../config/router/competition'
import RPayment from '../config/router/payment'
import RWxAccountBind from '../config/router/wxAccountBind'
import RAssignment from '../config/router/assignment'
import RJumpJumpCoin from '../config/router/jumpJumpCoin'
import RAssignmentRecord from '../config/router/assignmentRecord'
import RJuniorRefund from '../config/router/juniorRefund'
import RContactUs from '../config/router/contactUs'
import RRunTask from '../config/router/runTask'
import RStudent from '../config/router/student'
import RLuoHuIdentity from '../config/router/luohuIdentity'
import RCollegeRegist from '../config/router/collegeRegist'
import RPhysicalMeetStandard from '../config/router/physicalMeetStandard'
import RSummer2023Friends from '../config/router/summer2023Friends'
import RTzy from '../config/router/tzy'
import RAiTest from '../config/router/ai-test'
import RIntelligentClassRoom from '../config/router/intelligentClassrooom'
import RFitscreen from '../config/router/fitscreen'

import RDemo from './RDemo'
import RUser from './RUser'
import RSplus from './RSplus'
import RFeedback from './RFeedback'
import RATTestTTTS from './RATTestTTTS'
import RSportsCourse from './RSportsCourse'
import RPhysicalFitnessTest from './RPhysicalFitnessTest'

import { RApph5Activities } from 'kuaidong-activity'
import RTzyUniversityStudent from 'tzy-university-student'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('../views/Home.vue'),
    },
    {
      path: '/test',
      name: 'test',
      component: () => import('../views/Test.vue'),
      props: (route) => ({ ...route.query, ...route.params }),
      meta: {
        test: '测试页面',
        needOpenidUnderWechat: true,
      },
    },
    {
      path: '/weekly-sport-report',
      name: 'weekly_sport_report',
      component: () => import('../views/sports-weekly-report/Index.vue'),
      props: (route) => ({ ...route.query, ...route.params }),
      meta: {
        title: '运动周报',
      },
    },
    {
      path: '/weekly-sport-report-subscribe',
      name: 'weekly_sport_report_subscribe',
      component: () => import('../views/sports-weekly-report/Subscribe.vue'),
      props: (route) => ({ ...route.query, ...route.params }),
      meta: {
        title: '运动周报订阅',
        needLogin: true,
        needOpenidUnderWechat: true,
      },
    },
    {
      path: '/crazyrope/drill-report',
      name: 'CrazyRopeDrillReport',
      component: () => import('../views/crazyrope/DrillReport.vue'),
    },
    {
      path: '/jumpstar/drill-report',
      name: 'JumpStarDrillReport',
      component: () => import('../views/crazyrope/DrillReportOfJumpStar.vue'),
    },
    {
      path: '/crazyrope/drill-report-live-pk',
      name: 'CrazyRopeLivePkDrillReport',
      component: () => import('../views/crazyrope/PKDrillReport.vue'),
      props: (route) => ({ ...route.query, ...route.params }),
    },
    {
      path: '/ai-test-report',
      name: 'ai_test_report',
      component: () => import('../views/ai-test-report/Index.vue'),
      props: (route) => ({ ...route.query, ...route.params }),
      meta: {
        title: '测试报告详情',
      },
    },
    {
      path: '/ai-deep-report',
      name: 'ai_deep_report',
      component: () => import('../views/ai-deep-report/Index.vue'),
      props: (route) => ({ ...route.query, ...route.params }),
      meta: {
        title: 'AI运动报告',
      },
    },
    {
      path: '/crazyrope/jkc-report',
      name: 'CrazyRopeJkcReport',
      component: () => import('../views/crazyrope/jkcReport/Index.vue'),
      props: (route) => ({ ...route.query, ...route.params }),
    },
    {
      path: '/crazyrope/relax-drill-report',
      name: 'crazyrope_relax_drill_report',
      component: () => import('../views/crazyrope/relax-drill-report/Index.vue'),
      props: (route) => ({ ...route.query, ...route.params }),
      meta: {
        title: '训练报告',
      },
    },
    {
      path: '/crazyrope/rely-info-user',
      name: 'CrazyRopeRelyInfo',
      component: () => import('../views/crazyrope/RelyInfo/UserMain.vue'),
    },
    {
      path: '/crazyrope/rely-info-user-base',
      name: 'CrazyRopeRelyInfoBase',
      component: () => import('../views/crazyrope/RelyInfo/UserBase.vue'),
    },
    {
      path: '/crazyrope/rely-info-user-usage',
      name: 'CrazyRopeRelyInfoUsage',
      component: () => import('../views/crazyrope/RelyInfo/UserUsage.vue'),
    },
    {
      path: '/crazyrope/rely-info-user-id',
      name: 'CrazyRopeRelyInfoID',
      component: () => import('../views/crazyrope/RelyInfo/UserID.vue'),
    },
    {
      path: '/crazyrope/rely-info-user-dev',
      name: 'CrazyRopeRelyInfoDev',
      component: () => import('../views/crazyrope/RelyInfo/UserDev.vue'),
    },
    {
      path: '/crazyrope/rely-info-sdk',
      name: 'CrazyRopeRelyInfoSDK',
      component: () => import('../views/crazyrope/RelyInfo/SDK.vue'),
    },
    {
      path: '/invite-teacher-join-class',
      name: 'InviteTeacherPage',
      component: () => import('../views/invite-teacher/InviteTeacherPage.vue'),
    },
    {
      path: '/invite-teacher-feedback',
      name: 'InviteTeacherFeedBackPage',
      component: () => import('../views/invite-teacher/InviteTeacherFeedBackPage.vue'),
    },
    {
      path: '/fill-missing-school',
      name: 'FillMissingSchool',
      component: () => import('../views/fill-missing-school/Index.vue'),
    },
    {
      path: '/about',
      name: 'about',
      component: () => import('../views/About.vue'),
    },
    {
      path: '/jumprope-exam-cert',
      name: 'JumpRopeExamCert',
      component: () => import('../views/jumpropeExam/Cert.vue'),
    },
    {
      path: '/qr/user',
      name: 'qrcode-user',
      component: () => import('../views/crazyrope/Qrcode/User.vue'),
      props: (route) => ({ id: route.query.user_id, channel: route.query.ts_channel }),
    },
    {
      path: '/homework-cheat-info',
      name: 'HomeworkCheatInfo',
      component: () => import('../views/crazyrope/HomeworkCheatInfo.vue'),
      props: (route) => ({ id: route.query.id }),
    },
    {
      path: '/regist-with-school',
      name: 'RegistWithSchool',
      component: () => import('../views/crazyrope/RealNameRegist.vue'),
      props: (route) => ({
        token: route.query.school_id,
        target: route.query?.target || '',
        openid: route.query?.openid,
      }),
      meta: {
        keepAlive: true,
      },
    },
    {
      path: '/real-name-regist',
      name: 'RegistWithSportsTeam',
      component: () => import('../views/crazyrope/SportsTeamRegist.vue'),
      props: (route) => ({ ...route.query }),
      meta: {
        keepAlive: true,
      },
    },
    {
      path: '/group-rank',
      name: 'GroupRank',
      component: () => import('../views/crazyrope/GroupRank.vue'),
    },
    {
      path: '/password-modify',
      name: 'PasswordModify',
      component: () => import('../views/crazyrope/PasswordModify.vue'),
      props: (route) => ({ verify: !!route.query.v, user_id: route.query.user_id || undefined }),
    },
    {
      path: '/group-tip-off',
      name: 'GroupTipOff',
      component: () => import('../views/crazyrope/GroupTipOff.vue'),
    },
    {
      path: '/run-rank',
      name: 'RunRank',
      component: () => import('../views/crazyrope/RunRank.vue'),
      props: (route) => ({ ...route.query }),
    },
    {
      path: '/account-bind',
      name: 'AccountBind',
      component: () => import('../views/crazyrope/AccountBind.vue'),
      props: (route) => ({ ...route.query }),
    },
    {
      path: '/backend-setting-guide',
      name: 'BackendSettingGuide',
      component: () => import('../views/crazyrope/BackendSettingGuide.vue'),
      props: (route) => ({ ...route.query }),
    },
    {
      path: '/medal-challenge/:id',
      name: 'MedalChallenge',
      component: () => import('../views/activity/medal-challenge/index.vue'),
      props: true,
    },
    {
      path: '/medal-challenge/v2/:id',
      name: 'MedalChallenge-V2',
      component: () => import('../views/activity/medal-challenge/index.vue'),
      props: (route) => ({ ...route.params, version: 1 }),
    },
    {
      path: '/medal-challenge/:id/cert',
      name: 'MedalChallengeCert',
      component: () => import('../views/activity/medal-challenge/Cert.vue'),
      props: true,
    },
    {
      path: '/medal-challenge-serials/:id',
      name: 'MedalChallengeSerials',
      component: () => import('../views/activity/medal-challenge/Serials.vue'),
      props: true,
    },
    {
      path: '/cert-dl',
      name: 'cert_dl',
      component: () => import('../views/cert/Dl.vue'),
      props: (route) => ({ ...route.query }),
      meta: {
        title: '获奖详情',
      },
    },
    {
      path: '/cert-dl-by-id',
      name: 'cert_dl_by_id',
      component: () => import('../views/cert/DlById.vue'),
      props: (route) => ({ ...route.query }),
      meta: {
        title: '获奖详情',
      },
    },
    {
      path: '/delivery-address-edit',
      name: 'delivery_address_edit',
      component: () => import('../views/delivery-address/Edit.vue'),
      props: (route) => ({ ...route.query, orderId: route.query.order_id }),
      meta: {
        title: '修改收货地址',
      },
    },
    {
      path: '/delivery-address-edit-success',
      name: 'delivery_address_edit_success',
      component: () => import('../views/delivery-address/EditSuccess.vue'),
      props: (route) => ({ ...route.query }),
      meta: {
        title: '修改收货地址',
      },
    },
    {
      path: '/slider-verify',
      name: 'SliderVerify',
      component: () => import('../views/crazyrope/SliderVerify.vue'),
      props: (route) => ({
        phone: route.query.p,
        region: route.query.r || '86',
        account: route.query.a,
        accountType: route.query.t,
      }),
      meta: {
        title: '账号安全',
      },
    },
    {
      path: '/invite',
      name: 'invite',
      component: () => import('../views/crazyrope/Invite2/index.vue'),
    },
    {
      path: '/invite2-landing/:id',
      name: 'invite2-landing',
      component: () => import('../views/crazyrope/Invite2/Landing.vue'),
      props: true,
    },
    {
      path: '/user-report/:id',
      name: 'user-report',
      component: () => import('../views/user-report/Index.vue'),
      props: true,
    },
    {
      path: '/invite-landing/:id',
      name: 'invite-landing',
      component: () => import('../views/crazyrope/Invite/Landing.vue'),
      props: true,
    },
    {
      path: '/student-ask-for-leave',
      name: 'student_ask_for_leave',
      meta: {
        title: '请假记录',
      },
      component: () => import('../views/studentAskForLeave/AskForLeaveRecords.vue'),
    },

    {
      path: '/student-create-leave-record',
      name: 'student_create_leave_record',
      meta: {
        title: '发起请假',
      },
      component: () => import('../views/studentAskForLeave/Create.vue'),
    },

    {
      path: '/student-leave-record-detail',
      name: 'student_leave_record_detail',
      meta: {
        title: '请假信息',
      },
      component: () => import('../views/studentAskForLeave/AskForLeaveDetails.vue'),

      props: (route) => ({ id: route.query.id }),
    },
    {
      path: '/mall/real-commodity/:id/landing',
      name: 'mall_real-commodity_landing',
      component: () => import('../views/activity/mall/RealCommodityLanding.vue'),
      props: true,
    },
    {
      path: '/mall/show-window/440731053846498324',
      name: 'mall_show_window_b',
      component: () => import('../views/activity/mall/ShowWindowTmpB.vue'),
      props: { id: '440731053846498324' },
    },
    {
      path: '/mall/show-window/top-player',
      name: 'mall_show_top_player',
      component: () => import('../views/activity/mall/TopPlayer.vue'),
      props: (r) => ({ ts: +r.query.ts }),
    },
    {
      path: '/mall/show-window/aquatics',
      name: 'mall_show_aquatics',
      component: () => import('../views/activity/mall/AquaticsShop.vue'),
    },
    {
      path: '/mall/show-window/box',
      name: 'mall_show_box',
      component: () => import('../views/activity/mall/BoxShop.vue'),
    },
    {
      path: '/mall/show-window/children-day',
      name: 'mall_children_day',
      component: () => import('../views/activity/mall/ChildrenDay.vue'),
    },
    {
      path: '/mall/show-window/sword',
      name: 'mall_show_sword',
      component: () => import('../views/activity/mall/Sword.vue'),
    },
    {
      path: '/mall/show-window/equipment',
      name: 'mall_show_equipment',
      component: () => import('../views/activity/mall/Equipment.vue'),
    },
    {
      path: '/mall/show-window/duanwu',
      name: 'mall_show_duanwu',
      component: () => import('../views/activity/mall/Duanwu.vue'),
    },
    {
      path: '/mall/show-window/changan',
      name: 'mall_show_changan',
      component: () => import('../views/activity/mall/Changan.vue'),
    },
    {
      path: '/mall/show-window/super-hero',
      name: 'mall_show_super_hero',
      component: () => import('../views/activity/mall/SuperHero.vue'),
    },
    {
      path: '/mall/show-window/super-hero2',
      name: 'mall_show_super_hero2',
      component: () => import('../views/activity/mall/SuperHero2.vue'),
    },
    {
      path: '/mall/show-window/super-hero3',
      name: 'mall_show_super_hero3',
      component: () => import('../views/activity/mall/SuperHero3.vue'),
    },
    {
      path: '/mall/show-window/super-hero4',
      name: 'mall_show_window_super_hero4',
      component: () => import('../views/activity/mall/SuperHero4.vue'),
      props: (route) => ({ ...route.query, ...route.params }),
      meta: {
        title: '英雄传奇',
      },
    },
    {
      path: '/mall/show-window/super-hero5',
      name: 'mall_show_window_super_hero5',
      component: () => import('../views/activity/mall/super-hero5/Index.vue'),
      props: (route) => ({ ...route.query, ...route.params }),
      meta: {
        title: '英雄传奇',
      },
    },
    {
      path: '/mall/show-window/seaside',
      name: 'mall_show_seaside',
      component: () => import('../views/activity/mall/Seaside.vue'),
    },
    {
      path: '/mall/vip-trial/:id',
      name: 'mall-vip-trial',
      component: () => import('../views/activity/mall/VipTrial.vue'),
      props: true,
    },
    {
      path: '/mall/show-window/:id',
      name: 'mall_show_window',
      component: () => import('../views/activity/mall/ShowWindowTmpA.vue'),
      props: true,
    },
    {
      path: '/mall/s-plus-activity',
      name: 'mall_s_plus_activity',
      component: () => import('../views/activity/mall/SPlus.vue'),
      props: true,
    },
    {
      path: '/mall/s-plus-as-2023',
      name: 'mall_s_plus_as_2023',
      component: () => import('../views/activity/mall/SPlusAS2023.vue'),
    },
    {
      path: '/mall/fun-activity',
      name: 'mall_fun_activity',
      component: () => import('../views/activity/mall/Fun.vue'),
      props: true,
    },
    {
      path: '/mall/rope-activity',
      name: 'mall_rope_activity',
      component: () => import('../views/activity/mall/Rope.vue'),
      props: true,
    },
    {
      path: '/mall/zodiac-signs',
      name: 'mall_zodiac_signs',
      component: () => import('../views/activity/mall/ZodiacSigns.vue'),
      props: true,
      meta: {
        title: '星座奇谭',
      },
    },
    {
      path: '/mall/national-day',
      name: 'mall_national_day',
      component: () => import('../views/activity/mall/NationalDay.vue'),
      props: true,
      meta: {
        title: '国庆假期福利大放送',
      },
    },
    {
      path: '/mall/outing',
      name: 'mall_outing',
      component: () => import('../views/activity/mall/Outing.vue'),
      props: true,
      meta: {
        title: '郊游穿搭指南',
      },
    },
    {
      path: '/mall/speed-racer',
      name: 'mall_speed_racer',
      component: () => import('../views/activity/mall/SpeedRacer.vue'),
      props: true,
      meta: {
        title: '极速快车手',
      },
    },
    {
      path: '/drill-friend-invite',
      name: 'drill_friend_invite',
      component: () => import('../views/crazyrope/DrillFriendInvite.vue'),
      props: (route) => ({ id: route.query.u, timeStamp: route.query.t }),
    },
    {
      path: '/activity/new-year-2023',
      name: 'new-year-2023',
      component: () => import('../views/activity/mall/NewYear2023.vue'),
    },
    {
      path: '/activity/golf-shop',
      name: 'golf-shop',
      component: () => import('../views/activity/mall/Golf.vue'),
    },
    {
      path: '/activity/xiyou-shop',
      name: 'xiyou-shop',
      component: () => import('../views/activity/mall/XiYou.vue'),
    },
    {
      path: '/activity/mini-hero',
      name: 'mini-hero',
      component: () => import('../views/activity/mall/MiniHero.vue'),
    },
    {
      path: '/activity/xyy-shop',
      name: 'xyy-shop',
      component: () => import('../views/activity/mall/XiYangYang.vue'),
    },
    {
      path: '/activity/xyy-shop2',
      name: 'activity_xyy_shop2',
      component: () => import('../views/activity/mall/XiYangYang2.vue'),
    },
    {
      path: '/activity/xyy-shop3',
      name: 'activity_xyy_shop3',
      component: () => import('../views/activity/mall/XiYangYang3.vue'),
    },
    {
      path: '/activity/basketball-shop',
      name: 'basketball-shop',
      component: () => import('../views/activity/mall/Basketball.vue'),
    },
    {
      path: '/activity/basketball-shop2',
      name: 'basketball-shop2',
      component: () => import('../views/activity/mall/Basketball2.vue'),
    },
    {
      path: '/activity/champion-shop',
      name: 'champion-shop',
      component: () => import('../views/activity/mall/Champion.vue'),
    },
    {
      path: '/activity/tgc-shop-jy',
      name: 'tgc-shop-jy',
      component: () => import('../views/activity/mall/TgcA.vue'),
    },
    {
      path: '/activity/tgc-shop-gs',
      name: 'tgc-shop-gs',
      component: () => import('../views/activity/mall/TgcB.vue'),
    },
    {
      path: '/activity/duanwu-2023',
      name: 'duanwu-2023',
      component: () => import('../views/activity/duanwu-2023/index.vue'),
    },
    {
      path: '/activity/changan',
      name: 'changan',
      component: () => import('../views/activity/changan/Index.vue'),
    },
    {
      path: '/activity/vip-summer-2023',
      name: 'vip-summer-2023',
      component: () => import('../views/activity/vip-summer-2023/index.vue'),
    },
    {
      path: '/activity/vip-summer-2023/rewards',
      name: 'vip-summer-2023-rewards',
      component: () => import('../views/activity/vip-summer-2023/Rewards.vue'),
    },
    {
      path: '/activity/vip-autumn-2023',
      name: 'vip-autumn-2023',
      props: (route) => ({ ...route.query }),
      component: () => import('../views/activity/vip-autumn-2023/index.vue'),
    },
    {
      path: '/activity/vip-autumn-2023/rewards',
      name: 'vip-autumn-2023-rewards',
      component: () => import('../views/activity/vip-autumn-2023/Rewards.vue'),
    },
    {
      path: '/activity/vip-autumn-2023-2',
      name: 'vip-summer-2023-2',
      props: (route) => ({ ...route.query }),
      component: () => import('../views/activity/vip-autumn-2023-2/index.vue'),
    },
    {
      path: '/activity/vip-autumn-2023-2/rewards',
      name: 'vip-autumn-2023-2-rewards',
      component: () => import('../views/activity/vip-autumn-2023-2/Rewards.vue'),
    },
    {
      path: '/activity/novice-packs',
      name: 'activity_novice_packs',
      component: () => import('../views/activity/mall/NovicePacks.vue'),
      meta: {
        title: '新手礼包',
      },
    },
    {
      path: '/mall/icecream',
      name: 'mall_icecream',
      component: () => import('../views/activity/mall/icecream/Index.vue'),
      meta: {
        title: '清甜夏日',
      },
    },
    {
      path: '/mall/hot-selling',
      name: 'mall_hot_selling',
      component: () => import('../views/activity/mall/hot-selling/Index.vue'),
      meta: {
        title: '热销排行榜',
      },
    },
    {
      path: '/mall/spring-outing',
      name: 'mall_spring_outing',
      component: () => import('../views/activity/mall/SpringOuting.vue'),
      meta: {
        title: '春日野营季',
      },
    },
    {
      path: '/activity/summer-challenge/:id',
      name: 'summer-challenge',
      component: () => import('../views/activity/summer-challenge-2023/index.vue'),
      props: true,
    },
    {
      path: '/zhoukan/01',
      name: 'zhoukan_01',
      props: (route) => ({ ...route.query }),
      component: () => import('../views/zhou-kan/zhoukan/index.vue'),
    },
    {
      path: '/activity/cut-fruit',
      name: 'cut-fruit',
      props: (route) => ({ ...route.query }),
      component: () => import('../views/activity/cut-fruit/index.vue'),
    },
    {
      path: '/zhoukan/02',
      name: 'zhoukan_02',
      props: (route) => ({ ...route.query }),
      component: () => import('../views/zhou-kan/lian-jin/index.vue'),
    },
    {
      path: '/semester-card-2023',
      name: 'semester_card_2023',
      props: (route) => ({ ...route.query }),
      component: () => import('../views/semster-card/index.vue'),
    },
    {
      path: '/mall/show-window-wulin',
      name: 'mall_show_wulin',
      props: (route) => ({ ...route.query }),
      component: () => import('../views/activity/mall/Wulin.vue'),
    },
    {
      path: '/zhoukan/03',
      name: 'zhoukan_03',
      props: (route) => ({ ...route.query }),
      component: () => import('../views/zhou-kan/yayun/index.vue'),
    },
    {
      path: '/party-season',
      name: 'party_season',
      props: (route) => ({ ...route.query }),
      component: () => import('../views/party-season/index.vue'),
    },
    {
      path: '/party-season-2',
      name: 'party_season_2',
      props: (route) => ({ ...route.query }),
      component: () => import('../views/party-season/v2.vue'),
    },
    {
      path: '/activity/vip-autumn-2023-3',
      name: 'vip-summer-2023-3',
      props: (route) => ({ ...route.query }),
      component: () => import('../views/activity/vip-autumn-2023-3/index.vue'),
    },
    {
      path: '/activity/vip-autumn-2023-3/rewards',
      name: 'vip-autumn-2023-3-rewards',
      component: () => import('../views/activity/vip-autumn-2023-3/Rewards.vue'),
    },
    {
      path: '/activity/vip-autumn-2023-4',
      name: 'vip-summer-2023-4',
      props: (route) => ({ ...route.query }),
      component: () => import('../views/activity/vip-autumn-2023-4/index.vue'),
    },
    {
      path: '/activity/vip-autumn-2023-4/rewards',
      name: 'vip-autumn-2023-4-rewards',
      component: () => import('../views/activity/vip-autumn-2023-4/Rewards.vue'),
    },
    {
      path: '/activity/vip-autumn-2023-5',
      name: 'vip-autumn-2023-5',
      props: (route) => ({ ...route.query }),
      component: () => import('../views/activity/vip-autumn-2023-5/index.vue'),
    },
    {
      path: '/activity/vip-autumn-2023-5/rewards',
      name: 'vip-autumn-2023-5-rewards',
      component: () => import('../views/activity/vip-autumn-2023-5/Rewards.vue'),
    },
    {
      path: '/mall/show-window-moon-hero',
      name: 'mall_show_moon_hero',
      props: (route) => ({ ...route.query }),
      component: () => import('../views/activity/mall/MoonHero.vue'),
    },
    {
      path: '/mall/show-window-three-kingdoms',
      name: 'mall_show_three_kingdoms',
      props: (route) => ({ ...route.query }),
      component: () => import('../views/activity/mall/ThreeKingdoms.vue'),
    },
    {
      path: '/mall/three-kingdoms2',
      name: 'mall_three_kingdoms2',
      component: () => import('../views/activity/mall/ThreeKingdoms2.vue'),
      props: (route) => ({ ...route.query, ...route.params }),
      meta: {
        title: '三国群英萃',
      },
    },
    {
      path: '/mall/show-window-7-to-season',
      name: 'mall_show_7_to_season',
      props: (route) => ({ ...route.query }),
      component: () => import('../views/activity/mall/SevenToSeason.vue'),
    },
    {
      path: '/mall/christmas',
      name: 'mall_christmas',
      component: () => import('../views/activity/mall/Christmas.vue'),
      props: (route) => ({ ...route.query, ...route.params }),
      meta: {
        title: '冰雪节集市',
      },
    },
    {
      path: '/mall/peak-match',
      name: 'mall_peak_match',
      component: () => import('../views/activity/mall/PeakMatch.vue'),
      props: (route) => ({ ...route.query, ...route.params }),
      meta: {
        title: '巅峰赛商店',
      },
    },
    {
      path: '/mall/peak-match2',
      name: 'mall_peak_match2',
      component: () => import('../views/activity/mall/PeakMatch2.vue'),
      props: (route) => ({ ...route.query, ...route.params }),
      meta: {
        title: '巅峰赛商店',
      },
    },
    {
      path: '/mall/the-lantern-festival',
      name: 'mall_the_lantern_festival',
      component: () => import('../views/activity/mall/TheLanternFestival.vue'),
      props: (route) => ({ ...route.query, ...route.params }),
      meta: {
        title: '元宵花灯会',
      },
    },
    {
      path: '/mall/sports-island',
      name: 'mall_sports_island',
      component: () => import('../views/activity/mall/SportsIsland.vue'),
      props: (route) => ({ ...route.query, ...route.params }),
      meta: {
        title: '运动岛设施馆',
      },
    },
    {
      path: '/mall/sports-island2',
      name: 'mall_sports_island2',
      component: () => import('../views/activity/mall/SportsIsland2.vue'),
      props: (route) => ({ ...route.query, ...route.params }),
      meta: {
        title: '运动岛设施馆',
      },
    },
    {
      path: '/mall/shining-star',
      name: 'mall_shining_star',
      component: () => import('../views/activity/mall/ShiningStar.vue'),
      props: (route) => ({ ...route.query, ...route.params }),
      meta: {
        title: '闪闪发光的你',
      },
    },
    {
      path: '/mall/magic-alchemy2',
      name: 'mall_magic_alchemy2',
      component: () => import('../views/activity/mall/magic-alchemy/Index.vue'),
      props: (route) => ({ ...route.query, ...route.params }),
      meta: {
        title: '魔法炼金坊II',
      },
    },
    {
      path: '/mall/ice-kingdom',
      name: 'mall_ice_kingdom',
      component: () => import('../views/activity/mall/ice-kingdom/Index.vue'),
      props: (route) => ({ ...route.query, ...route.params }),
      meta: {
        title: '冰雪王国盛宴',
      },
    },
    {
      path: '/mall/spring-dance',
      name: 'mall_spring_dance',
      component: () => import('../views/activity/mall/spring-dance/Index.vue'),
      props: (route) => ({ ...route.query, ...route.params }),
      meta: {
        title: '缎梦圆舞曲',
      },
    },
    {
      path: '/mall/shop/:id',
      name: 'mall_shop_id',
      component: () => import('../views/activity/mall/Shop.vue'),
      props: true,
    },
    {
      path: '/zhoukan/04',
      name: 'zhoukan_04',
      props: (route) => ({ ...route.query }),
      component: () => import('../views/zhou-kan/halloween-2023/index.vue'),
    },
    {
      path: '/zhoukan/05',
      name: 'zhoukan_05',
      component: () => import('../views/zhou-kan/winter-vacation-2023/Index.vue'),
      props: (route) => ({ ...route.query, ...route.params }),
      meta: {
        title: '寒假体感补给站',
      },
    },
    {
      path: '/zhoukan/06',
      name: 'zhoukan_06',
      component: () => import('../views/zhou-kan/cn-new-year-2024/Index.vue'),
      props: (route) => ({ ...route.query, ...route.params }),
      meta: {
        title: '春节体感补给站',
      },
    },
    {
      path: '/zhoukan/07',
      name: 'zhoukan_07',
      component: () => import('../views/zhou-kan/children-day-2024/Index.vue'),
      props: (route) => ({ ...route.query, ...route.params }),
      meta: {
        title: '奇幻王国之旅',
      },
    },
    {
      path: '/zhoukan/08',
      name: 'zhoukan_08',
      component: () => import('../views/zhou-kan/olympics-2024/Index.vue'),
      props: (route) => ({ ...route.query, ...route.params }),
      meta: {
        title: '燃情巴黎奥运',
      },
    },
    {
      path: '/zhoukan/09',
      name: 'zhoukan_09',
      component: () => import('../views/zhou-kan/explore-magical-forest/index.vue'),
      props: (route) => ({ ...route.query, ...route.params }),
      meta: {
        title: '探秘奇幻森林',
      },
    },
    {
      path: '/explosive-hero',
      name: 'explosive_hero',
      props: (route) => ({ ...route.query }),
      component: () => import('../views/explosive-hero/index.vue'),
    },
    {
      path: '/double-11-wish',
      name: 'double_11_wish',
      props: (route) => ({ ...route.query }),
      component: () => import('../views/double-11-wish/index.vue'),
      meta: {
        title: '许愿活动',
      },
    },
    {
      path: '/wxpublic-stu/wechat-stu-my-info',
      name: 'wechat_stu_my_info',
      props: (route) => ({ ...route.query }),
      component: () => import('../views/tzy/Regist/StuAccountMyInfo.vue'),
      meta: {
        title: '我的信息',
        needLogin: true,
      },
    },
    {
      path: '/wxpublic-stu/wechat-stu-join-class',
      name: 'wechat_stu_join_class',
      props: (route) => ({ ...route.query }),
      component: () => import('../views/tzy/Regist/StuWechatJoinClazz.vue'),
      meta: {
        title: '加入班级',
      },
    },
    {
      path: '/double-11-wish-records',
      name: 'double_11_wish_records',
      props: (route) => ({ ...route.query }),
      component: () => import('../views/double-11-wish/records.vue'),
      meta: {
        title: '心愿点数明细',
      },
    },
    {
      path: '/novice-tasks',
      name: 'novice_tasks',
      props: (route) => ({ ...route.query, ...route.params }),
      component: () => import('../views/novice-tasks/Index.vue'),
      meta: {
        title: '新手任务',
      },
    },
    ...RUser,
    ...RSplus,
    ...RAiTest,
    ...RATTestTTTS,
    ...RRunTask,
    ...RStudent,
    ...RFeedback,
    ...ExamRoutes,
    ...ReportRoutes,
    ...BattleRoutes,
    ...RSportsCourse,
    ...ActivityRoutes,
    ...CompetitionRoutes,
    ...RPhysicalFitnessTest,
    ...LiveCourseRoutes,
    ...RPayment,
    ...RWxAccountBind,
    ...RAssignment,
    ...RJumpJumpCoin,
    ...RAssignmentRecord,
    ...RJuniorRefund,
    ...RContactUs,
    ...RLuoHuIdentity,
    ...RCollegeRegist,
    ...RPhysicalMeetStandard,
    ...RSummer2023Friends,
    ...RIntelligentClassRoom,
    // 活动
    ...RApph5Activities,
    // 体智云大学
    RTzyUniversityStudent,
    // 体智云功能
    ...RTzy,
    ...RFitscreen,

    // demo pages
    ...RDemo,
  ],
})
